import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { NAV, LOGO_MAIN } from "../content";
import { useLang } from "../lang";
import { useAuth } from "../auth";

export default function Navbar() {
  const { lang, setLang, t } = useLang();
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => { setOpen(false); }, [pathname]);
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  const linkClass = (to) => {
    const active = to === "/" ? pathname === "/" : pathname.startsWith(to);
    return active ? "text-[#1d1d1f]" : "text-[#1d1d1f]/85 hover:text-[#1d1d1f]";
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-white/85 border-b border-[#d2d2d7]"
      data-testid="site-navbar"
    >
      <div className="max-w-[1200px] mx-auto px-6 h-14 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img src={LOGO_MAIN} alt="HGW Industry" className="h-6 md:h-7" />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((item) => (
            <Link
              key={item.id}
              to={item.to}
              data-testid={`nav-link-${item.id}`}
              className={`text-[13px] transition-colors ${linkClass(item.to)}`}
            >
              {lang === "it" ? item.it : item.en}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <div className="hidden md:flex items-center gap-1 text-[12px] text-[#1d1d1f]/70">
            <button data-testid="lang-it" onClick={() => setLang("it")} className={lang === "it" ? "text-[#1d1d1f]" : "hover:text-[#1d1d1f]"}>IT</button>
            <span>/</span>
            <button data-testid="lang-en" onClick={() => setLang("en")} className={lang === "en" ? "text-[#1d1d1f]" : "hover:text-[#1d1d1f]"}>EN</button>
          </div>
          <Link
            to={user ? "/area-riservata" : "/login"}
            data-testid="nav-b2b-cta"
            className="text-[13px] text-[#1D3F94] hover:underline hidden sm:inline"
          >
            {user ? t.portal : t.b2bLogin}
          </Link>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((o) => !o)}
            className="md:hidden text-[#1d1d1f] w-8 h-8 flex items-center justify-center"
            aria-label="Menu"
          >
            <div className="w-4 flex flex-col gap-1">
              <span className={`h-px bg-[#1d1d1f] transition-all ${open ? "rotate-45 translate-y-1" : ""}`} />
              <span className={`h-px bg-[#1d1d1f] transition-all ${open ? "opacity-0" : ""}`} />
              <span className={`h-px bg-[#1d1d1f] transition-all ${open ? "-rotate-45 -translate-y-1" : ""}`} />
            </div>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-[#d2d2d7]">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV.map((item) => (
              <Link
                key={item.id}
                to={item.to}
                data-testid={`nav-mobile-${item.id}`}
                className="text-left text-lg text-[#1d1d1f]"
              >
                {lang === "it" ? item.it : item.en}
              </Link>
            ))}
            <Link to={user ? "/area-riservata" : "/login"} className="text-lg text-[#1D3F94]">
              {user ? t.portal : t.b2bLogin}
            </Link>
            <div className="pt-4 border-t border-[#d2d2d7] flex items-center gap-2 text-sm">
              <button onClick={() => setLang("it")} className={lang === "it" ? "text-[#1d1d1f]" : "text-[#6e6e73]"}>IT</button>
              <span>/</span>
              <button onClick={() => setLang("en")} className={lang === "en" ? "text-[#1d1d1f]" : "text-[#6e6e73]"}>EN</button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
